import { mapActions } from 'vuex';

export const ALL_LOCATIONS = '';

export const toLocationId = (location) => {
  if (location === null || location === undefined) return ALL_LOCATIONS;
  if (typeof location === 'object') return toLocationId(location.value);
  return String(location);
};

export const toQueryDate = (date) => {
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
};

const fromQueryDate = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
  if (!match) return null;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return isNaN(date) ? null : date;
};

export default {
  data() {
    return {
      selectedDateRange: this.getInitialDateRange(),
      selectedLocation: this.getInitialLocation(),
      locations: [],
    };
  },
  computed: {
    locationOptions() {
      return [
        { name: 'All Locations', value: ALL_LOCATIONS },
        ...this.locations,
      ];
    },
    selectedLocationOption() {
      return this.locationOptions.find((option) => toLocationId(option) === this.selectedLocation) || null;
    },
    formattedDateRange() {
      const formatDate = (date) => new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Jakarta',
        day: 'numeric',
        month: 'short',
        year: '2-digit',
      }).format(new Date(date));

      const [start, end] = this.selectedDateRange;
      return `${formatDate(start)} - ${formatDate(end)}`;
    },
    filterPayload() {
      const [startDate, endDate] = this.selectedDateRange;
      return { startDate, endDate, locationId: this.selectedLocation };
    },
  },
  mounted() {
    this.fetchLocations();
  },
  methods: {
    ...mapActions('smartpin', ['getSmartpinLocationOptions']),

    getInitialDateRange() {
      const query = this.$route?.query || {};
      const start = fromQueryDate(query.start_date);
      const end = fromQueryDate(query.end_date);
      if (start && end && start <= end) return [start, end];

      const today = new Date();
      return [new Date(today.getFullYear(), today.getMonth(), 1), today];
    },

    getInitialLocation() {
      return toLocationId(this.$route?.query?.location_id);
    },

    async fetchLocations() {
      try {
        this.locations = await this.getSmartpinLocationOptions();
      } catch (error) {
        this.locations = [];
        this.alertTopEnd('error', error?.response?.data?.message || 'Failed to load locations', false);
      }
    },

    handleLocationChange(option) {
      const locationId = toLocationId(option);
      if (locationId === this.selectedLocation) return;

      this.selectedLocation = locationId;
      const query = { ...this.$route.query };
      if (locationId === ALL_LOCATIONS) {
        delete query.location_id;
      } else {
        query.location_id = locationId;
      }
      this.$router.replace({ query }).catch(() => {});
      this.onFilterChange();
    },

    handleDateRangeChange({ startDate, endDate }) {
      if (!startDate || !endDate) return;

      this.$router.replace({
        query: { ...this.$route.query, start_date: toQueryDate(startDate), end_date: toQueryDate(endDate) },
      }).catch(() => {});
      this.onFilterChange();
    },
  },
};
